import React from "react";
import "../../static/css/productoCard.css";
import { Card } from "react-bootstrap";
import {mensajeErrorPersonalizado} from "../../helpers/mensajesSwalError";

const ProductoCard = ({ producto, cantidad = 0, onAdd, onRemove, bodegaId }) => {
    // Bodega seleccionada
    const bodegaSeleccionada = producto.bodegas?.find(b => b.id === bodegaId);
    const stockBodega = bodegaSeleccionada
        ? Number(bodegaSeleccionada.productos_bodegas.stock)
        : 0;

    // Otras bodegas con stock
    const otrasBodegasConStock = producto.bodegas
            ?.filter(b => b.id !== bodegaId && Number(b.productos_bodegas.stock) > 0)
            .map(b => `${b.nombre}: ${b.productos_bodegas.stock}`)
        || [];

    let stockMensaje;

    if (stockBodega > 0) {
        stockMensaje = `Stock en esta bodega: ${stockBodega}`;
    }
    else if (otrasBodegasConStock.length > 0) {
        stockMensaje = (
            <>
                <span className="sin-stock-aqui">Sin stock aquí.</span>
                <br />
                <span className="stock-otras-bodegas">
                Disponible en
                <span className="lista-otras-bodegas">
                    {otrasBodegasConStock.map((b, index) => (
                        <li className={"mi-lista"} key={index}>{b}</li>
                    ))}
                </span>
            </span>
            </>
        );
    }
    else {
        stockMensaje = <span className="producto-agotado">Producto agotado</span>;
    }

    // Imagen del producto
    const imagenUrl = producto.paths_productos.length > 0
        ? `${process.env.REACT_APP_API_URL}/uploads/${producto.paths_productos[0].path}`
        : "https://placehold.co/300x200?text=Sin+Imagen&bg=cccccc&fc=000000";

    return (
        <div className="producto-card">
            {/* FOTO */}
            {producto.paths_productos.length === 0 ? (
                <Card.Img
                    variant="top"
                    src={imagenUrl}
                    style={{ height: "200px", objectFit: "cover" }}
                />
            ) : (
                <div
                    className="producto-img"
                    style={{
                        height: "200px",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundImage: `url(${imagenUrl})`
                    }}
                ></div>
            )}

            {/* INFO */}
            <div className="producto-info">
                <h4 className="producto-nombre">{producto.nombre}</h4>
                {stockBodega > 0? (<p className="producto-precio">${Number(producto.precio).toLocaleString()}</p>): (<p></p>)}
                <p className="producto-stock">{stockMensaje}</p>

                {/* CONTROLES */}
                <div className="producto-controles">
                    {cantidad > 0 && (
                        <>
                            <button
                                className="btn-round btn-remove"
                                onClick={() => onRemove(producto)}
                            >
                                ➖
                            </button>
                            <span className="producto-cantidad">{cantidad}</span>
                        </>
                    )}
                    {stockBodega > 0?(
                        <button
                            className="btn-round btn-add"
                            onClick={() => {
                                if (stockBodega > 0 && cantidad < stockBodega) {
                                    onAdd(producto);
                                } else if (stockBodega > 0) {
                                    mensajeErrorPersonalizado("No hay suficiente stock en esta bodega")
                                }
                            }}
                        >
                            ➕</button>
                    ):(<p></p>)}
                </div>
            </div>
        </div>
    );
};

export default ProductoCard;
